var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBigExclamationSensia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 108,
    viewBox: "0 0 121 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4995 12.7866L108.23 95.2533H12.769L60.4995 12.7866ZM1.80315 88.9146C-3.07766 97.3451 3.00751 107.931 12.7691 107.931H108.23C117.992 107.931 124.077 97.3451 119.196 88.9146L71.4657 6.44787C66.5848 -1.98262 54.4145 -1.98262 49.5337 6.44787L1.80315 88.9146ZM54.161 44.5436V63.5598C54.161 67.0461 57.0134 69.8985 60.4997 69.8985C63.986 69.8985 66.8384 67.0461 66.8384 63.5598V44.5436C66.8384 41.0573 63.986 38.2049 60.4997 38.2049C57.0134 38.2049 54.161 41.0573 54.161 44.5436ZM54.161 82.5759C54.161 79.0751 56.9989 76.2372 60.4997 76.2372C64.0005 76.2372 66.8384 79.0751 66.8384 82.5759C66.8384 86.0767 64.0005 88.9146 60.4997 88.9146C56.9989 88.9146 54.161 86.0767 54.161 82.5759Z",
    fill: "#B42B28"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigExclamationSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/big-exclamation-sensia.e5f4cb4488438e6b324a40d68ab03d57.svg";